(() => {
  'use strict';
  const catalog = () => window.Almeora?.cartCatalog || { offers: [], gifts: [] };
  const offerFor = (item) => catalog().offers.find((offer) => String(offer.variantId) === String(item.variant_id || item.id));
  const giftFor = (item) => catalog().gifts.find((gift) => String(gift.variantId) === String(item.variant_id || item.id));
  const managed = (item) => Boolean(giftFor(item) && item.properties?._almeora_gift === giftFor(item).key);
  const giftError = () => new Error('Your complimentary gifts could not be added. Please try again or contact us.');

  function requirements(items) {
    const required = { shipping: 0, ebook: 0, guarantee: 0 };
    items.forEach((item) => {
      const offer = offerFor(item);
      if (!offer) return;
      required.shipping += Number(item.quantity);
      if (offer.bottles === 5) {
        required.ebook += Number(item.quantity);
        required.guarantee += Number(item.quantity);
      }
    });
    return required;
  }

  function giftItem(key, quantity) {
    const gift = catalog().gifts.find((entry) => entry.key === key);
    if (!gift?.variantId || !gift.available || gift.price !== 0) throw giftError();
    return { id: gift.variantId, quantity, properties: { _almeora_gift: key } };
  }

  function addItems(parent) {
    const gifts = Object.entries(requirements([parent])).filter(([, count]) => count > 0);
    return [parent, ...gifts.map(([key, count]) => giftItem(key, count))];
  }

  function plan(items) {
    const required = requirements(items);
    const updates = {};
    const additions = [];
    Object.entries(required).forEach(([key, count]) => {
      const lines = items.filter((item) => managed(item) && giftFor(item).key === key);
      if (count > 0) giftItem(key, count); // Never silently replace a free gift with a paid product.
      if (!lines.length && count > 0) additions.push(giftItem(key, count));
      lines.forEach((line, index) => {
        const wanted = index === 0 ? count : 0;
        if (line.quantity !== wanted) updates[line.key] = wanted;
      });
    });
    return { updates, additions };
  }

  function bottleLabel(item) {
    const offer = offerFor(item);
    if (!offer) return '';
    const total = offer.bottles * item.quantity;
    return `${total} ${total === 1 ? 'bottle' : 'bottles'}`;
  }

  function savings(cart) {
    const referenceTotal = (cart.items || []).reduce((total, item) => {
      const original = Number(item.original_line_price) || Number(item.final_line_price) || 0;
      const compare = Number(offerFor(item)?.compareAtPrice) || 0;
      return total + Math.max(original, compare * item.quantity);
    }, 0);
    return Math.max(0, referenceTotal - (Number(cart.total_price) || 0));
  }

  function validity(cart, previous, now = Date.now()) {
    if (!cart.items?.length) return null;
    const signature = JSON.stringify([cart.currency, cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price]).sort((a, b) => String(a[0]).localeCompare(String(b[0])))]);
    if (previous?.signature === signature && Number.isFinite(previous.expiresAt)) return previous;
    return { signature, expiresAt: now + 5 * 60 * 1000, checked: false };
  }

  window.AlmeoraBundles = { offerFor, giftFor, managed, addItems, plan, bottleLabel, savings, validity };
})();
